import React, { useState, useRef, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { LogOut, User, LayoutDashboard, ChevronDown } from "lucide-react";
import "./Header.css";

function Header() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const menuRef = useRef(null);

  useEffect(() => {
    function handleClickOutside(event) {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setIsMenuOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  if (["/login", "/signup"].includes(location.pathname)) return null;

  const isLanding = location.pathname === "/";
  const headerClass = isLanding
    ? "atlas-header landing-mode"
    : "atlas-header app-mode";

  return (
    <header className={headerClass}>
      <div className="header-logo" onClick={() => navigate("/")}>
        <img src="/logo.png" alt="Atlas" className="logo-img" />
      </div>

      <div className="header-actions">
        {user ? (
          <>
            {/* Quick Access Dashboard Button (Only on Landing) */}
            {isLanding && (
              <button className="nav-btn" onClick={() => navigate("/analyze")}>
                <LayoutDashboard size={16} /> Dashboard
              </button>
            )}

            <div className="user-menu-container" ref={menuRef}>
              <div
                className={`user-trigger ${isMenuOpen ? "active" : ""}`}
                onClick={() => setIsMenuOpen(!isMenuOpen)}
              >
                <div className="avatar-circle">
                  {/* Initials or Icon */}
                  {user.name ? (
                    user.name.charAt(0).toUpperCase()
                  ) : (
                    <User size={18} />
                  )}
                </div>
                <ChevronDown size={14} className="chevron" />
              </div>

              {isMenuOpen && (
                <div className="dropdown-menu">
                  <div className="menu-header">
                    <span className="user-name">
                      {user.name || "Atlas User"}
                    </span>
                    <span className="user-email">{user.email}</span>
                  </div>

                  <div className="menu-divider"></div>

                  {/* Settings removed as requested */}

                  <button className="menu-item logout" onClick={logout}>
                    <LogOut size={16} /> Sign Out
                  </button>
                </div>
              )}
            </div>
          </>
        ) : (
          <div className="auth-buttons">
            <button className="text-btn" onClick={() => navigate("/login")}>
              Log in
            </button>
            <button className="primary-btn" onClick={() => navigate("/signup")}>
              Sign up
            </button>
          </div>
        )}
      </div>
    </header>
  );
}

export default Header;